const selectStyles = (tokens) => ({
    variants: {
        filled: {
            field: {
                background: tokens.Layer02,
                color: tokens.TextLight500,
                borderColor: tokens.BorderLight500,
                borderWidth: tokens.BorderWidth01,
                borderRadius: tokens.BorderRadius02,
                fontSize: tokens.TextBodyReg3FontSize,
                _hover: {
                    background: tokens.Layer01,
                    borderColor: tokens.BorderLight500,
                },
                _focus: {
                    outlineColor: tokens.BorderFocus,
                    outlineOffset: '2px',
                    outlineWidth: '2px',
                    borderColor: tokens.BorderDark800,
                    color: tokens.TextBlack800,
                    background: tokens.Layer01,
                },
                _focusVisible: {
                    shadow: 'none',
                },
                _invalid: {
                    borderWidth: tokens.Spacing02,
                    borderColor: tokens.BorderError,
                },
            },
        },
    },
});
export default selectStyles;
